export default "__VITE_ASSET__ZOchOhcS__"